import React, { Fragment, useEffect, useState } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import VeiculosService from '../../../../services/veiculos-auth';
import SecretariaService from '../../../../services/secretaria';



const Veiculos = () => {
    const [marca, setMarca] = useState("");
    const [modelo, setModelo] = useState("");
    const [placa, setPlaca] = useState("");
    const [secretaria, setSecretaria] = useState("");
    const [finalidade, setFinalidade] = useState("");
    const [tipo, setTipo] = useState("");
    const [situacao, setSituacao] = useState("");
    const [categoria, setCategoria] = useState("");
    const [proprietario, setProprietario] = useState("");
    const [secretarias, setSecretarias] = useState([]);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const veiculo = await VeiculosService.cadastro({
                marca: marca,
                modelo: modelo,
                placa: placa,
                finalidade: finalidade,
                tipo: tipo,
                situacao: situacao,
                categoria: categoria,
                proprietario: proprietario,
                secretaria: secretaria
            })
            if (veiculo.data["_id"]) {
                alert("Veículo cadastrado com sucesso!")
                setSucesso(true);
            }
            else {
                alert(veiculo.data["error"]);
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        montaSec()
    }, [])

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setMarca("");
        setModelo("");
        setPlaca("");
        setSecretaria("");
        setFinalidade("");
        setTipo("");
        setSituacao("");
        setCategoria("");
        setProprietario("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={3}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Processo">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="marca">
                                <FloatingLabel
                                    label="Marca"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="marca"
                                        value={marca}
                                        onChange={e => setMarca(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="modelo">
                                <FloatingLabel
                                    label="Modelo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="modelo"
                                        value={modelo}
                                        onChange={e => setModelo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="placa">
                                <FloatingLabel
                                    label="Placa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="placa"
                                        value={placa}
                                        onChange={e => setPlaca(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Finalidade">
                                <FloatingLabel
                                    label="Finalidade"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="finalidade"
                                        value={finalidade}
                                        onChange={e => setFinalidade(e.target.value)}
                                        as="textarea"
                                        rows="3" />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="tipo"
                                        value={tipo}
                                        onChange={e => setTipo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Inativo">Inativo</option>
                                        <option value="Em Manutenção">Em Manutenção</option>
                                        <option value="Aguardando Leilão">Aguardando Leilão</option>
                                        <option value="Perda Total">Perda Total</option>
                                        <option value="Leiloado">Leiloado</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Próprio">Próprio</option>
                                        <option value="Locado">Locado</option>
                                        <option value="Doado">Doado</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Proprietario">
                                <FloatingLabel
                                    label="Proprietário"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Proprietario"
                                        name="proprietario"
                                        onChange={e => setProprietario(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Prefeitura Municipal de Macuco">Prefeitura Municipal de Macuco</option>
                                        <option value="Governo do Estado do Rio de Janeiro">Governo do Estado do Rio de Janeiro</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal da Educação">Fundo Municipal da Educação</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal da Criança e do Adolescente">Fundo Municipal da Criança e do Adolescente</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/veiculos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Veículo cadastrado com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/veiculos/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem da Frota Municipal
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/veiculos'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Veiculos;